module.exports = __webpack_public_path__ + "static/img/scaleTip.bbe2220.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scaleTip.svg
// module id = LxRp
// module chunks = 1